export default "__VITE_ASSET__fe21aa0b__"